import { render, staticRenderFns } from "./RelatorioVencimentoList.vue?vue&type=template&id=00dc7b4b&scoped=true"
import script from "./RelatorioVencimentoList.vue?vue&type=script&lang=js"
export * from "./RelatorioVencimentoList.vue?vue&type=script&lang=js"
import style0 from "./RelatorioVencimentoList.vue?vue&type=style&index=0&id=00dc7b4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dc7b4b",
  null
  
)

export default component.exports